import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import DailyActivity from 'components/daily_activity/daily_activity';
import { StreakIcon } from '@seedlang/icons';
import ErrorBoundary from 'components/hoc/error_boundary';
import styled from '@emotion/styled';
import HeaderPopup from 'components/header_popup';
import Text from 'components/text';

const Wrapper = styled.div`

`;

const CalendarWrapper = styled.div`
  margin: 20px;
`;

const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px 30px;
`;

const StreakWrapper = styled.div`
  width: 160px;
  height: 160px;
  background: #FFF;
  border-radius: 50%;
  border: 10px solid orange;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

const NoteWrapper = styled.div`
  width: 300px;
  max-width: 100%;
`;

@observer
class StreakWithPopup extends React.Component {

  renderDailyActivity() {
    return (
      <DailyActivity
        store={AppUI.authUserDailyXpCountStore}
        dailyXpGoal={AppUI.user?.dailyXpGoal}
        userId={AppUI.user?.id}
        todaysDate={AppUI.user?.todaysDate}
      />
    );
  }

  render() {
    return (
      <Wrapper>
        <HeaderPopup
          height={AppUI.layout.isMobile ? AppUI.layout.mobileContentHeight : null}
          title={AppUI.layout.isMobile ? 'Streak' : 'My Activity'}
          background={this.props.background}
          arrowRight={AppUI.layout.isMobile ? 17 : 56}
          right='-50px'
          width={AppUI.layout.isMobile ? '100%' : '255px'}
          onClickIcon={() => AppUI.toggleStreakPopupOpened()}
          popupOpened={AppUI.streakPopupOpened}
          icon={
            <StreakIcon
              user={AppUI.user}
              color='rgba(255, 255, 255, 0.8)'
              width={AppUI.layout.isMobile ? '10px' : '13px'}
              top={AppUI.layout.isMobile ? '3px' : 0}
              fontSize={AppUI.layout.isMobile ? '10px' : '12px'}
            />
          }
        >
          {
            AppUI.layout.isMobile ? (
              <MobileWrapper>
                <Text
                  heading={2}
                  bold
                  center
                  margin={AppUI.user.currentStreakCount === 0 ? '10px 0' : '10px 0 20px'}
                >
                  {AppUI.user.currentStreakCount === 0 ? "You don't have a current streak." : `You have a ${AppUI.user.currentStreakCount} day streak!`}
                </Text>
                {
                  AppUI.user.currentStreakCount === 0 &&
                  <NoteWrapper>
                    <Text
                      color='#999'
                      fontSize='14px'
                      center
                      margin='0 0 20px'
                    >
                      {`Your "streak" is the number of consecutive days you have earned at least ${AppUI.user.dailyXpGoal} XP.`}
                    </Text>
                  </NoteWrapper>
                }
                <StreakWrapper>
                  <StreakIcon
                    width='60px'
                    height='100px'
                    user={AppUI.user}
                    full
                    hideStreakNumber
                  />
                </StreakWrapper>
                <Text
                  heading={2}
                  bold
                  center
                  margin='0 0 20px'
                >
                  XP Progress
                </Text>
                {this.renderDailyActivity()}
              </MobileWrapper>
            ) : (
              <CalendarWrapper>
                {this.renderDailyActivity()}
              </CalendarWrapper>
            )
          }
        </HeaderPopup>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(StreakWithPopup);
